/**
 * 
 * @param {string} name 
 * @returns 
 */

const url = `app`
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`

export const LOAD_EMPLOYEE = `${url}/LOAD_EMPLOYEE`
export const LOAD_EMPLOYEE_SUCCESS = `${url}/LOAD_EMPLOYEE_SUCCESS`
export const LOAD_EMPLOYEE_ERROR = `${url}/LOAD_EMPLOYEE_ERROR`

export const LOAD_DROPDOWN = `${url}/LOAD_DROPDOWN`
export const LOAD_DROPDOWN_SUCCESS = `${url}/LOAD_DROPDOWN_SUCCESS`
export const LOAD_DROPDOWN_ERROR = `${url}/LOAD_DROPDOWN_ERROR`


const constants = {
 
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,

  LOAD_DROPDOWN,
  LOAD_DROPDOWN_SUCCESS,
  LOAD_DROPDOWN_ERROR,

  LOAD_RECORDS_VALID_CACHE

}

export default constants
